import { getListIdForFilters } from '../helper';

// ACCIONES DE LISTADO DE VISITAS
export const practiceListActions = {

    LOAD_PRACTICES:'LOAD_PRACTICES',
    REJECT_PRACTICE: 'REJECT_PRACTICE',

    FETCH_PRACTICES_SUCCESS:'FETCH_PRACTICES_SUCCESS',
    FETCH_PRACTICES_FAILED:'FETCH_PRACTICES_FAILED',
    FETCH_PRACTICES_PENDING:'FETCH_PRACTICES_PENDING',

    fetchPracticesSuccess: (practiceListId, {data}) => ({
      type: practiceListActions.FETCH_PRACTICES_SUCCESS,
      payload: {
        practiceListId,
        data
      }
    }),

    fetchPracticesFailed: error =>({
        type:practiceListActions.FETCH_PRACTICES_FAILED,
        payload: error
    }),

    fetchPracticesPending: practiceListId =>({
        type:practiceListActions.FETCH_PRACTICES_PENDING,
        payload:{
          practiceListId
        }
    }),

    loadPractices: (filters, practiceListId) => {     
      let new_filters = filters.toJS ? filters.toJS() : filters
      return ({
        type: practiceListActions.LOAD_PRACTICES,
        payload: {
          practiceListId: (practiceListId) ? practiceListId : getListIdForFilters(new_filters),
          filters: new_filters,
        }
      })
    },

    rejectPractice: (practice_id, motive) => ({
        type: practiceListActions.REJECT_PRACTICE,
        payload: {
          id: practice_id,
          motive
        }
    })
}

export const practiceListRequestActions = {
    failed: practiceListActions.fetchPracticesFailed,
    success: practiceListActions.fetchPracticesSuccess,
    pending: practiceListActions.fetchPracticesPending
}
